<template>
  <section class="notifications section">
    <div class="container">
      <h1 class="title">Edit Notification Settings</h1>
      <loading v-if="loading" class="white-bg shadow-card" />
      <div class="card shadow-card" v-if="!loading && notification">
        <div class="card-body">
          <form @submit.prevent="updateNotification">
            <div class="form-group">
              <label>Name</label>
              <input
                type="text"
                v-model="notification.setting_name"
                disabled
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Title</label>
              <input
                type="text"
                name="title"
                v-model="notification.title"
                required
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label>Description</label>
              <textarea
                v-model="notification.details"
                v-autosize
                required
                class="form-control"
                rows="3"
                ref="details"
                placeholder="Add notification details..."
              ></textarea>
            </div>
            <div class="form-group mb-5">
              <label>Status</label>
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch1"
                  v-model="notification.active"
                />
                <label
                  class="custom-control-label cursor-pointer"
                  for="customSwitch1"
                >
                  <badge
                    type="pill"
                    :color="notification.active ? 'success' : 'danger'"
                    v-html="notification.active ? 'Active' : 'Inactive'"
                  ></badge>
                </label>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <button
                type="submit"
                :disabled="saving"
                class="btn btn-primary btn-block btn-300"
              >
                <span v-if="!saving">Update Notification</span>
                <span
                  class="spinner-border spinner-border-sm"
                  v-if="saving"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "NotificationsSettingsEdit",
  computed: {
    ...mapState(["saving", "loading", "notifications"]),
    notification: function () {
      const notification = this.notifications.notification;
      notification.details = notification.details.split(/\\r?\\n/).join("\n");
      notification.details = notification.details.split(/\r/).join("");
      return notification;
    },
    id: function () {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.$store.commit("SET_LOADING_STATE", true, { root: true });
    this.$store.dispatch("notifications/get", this.id);
  },
  methods: {
    updateNotification: function () {
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      this.$store.dispatch("notifications/update", this.notification);
    },
  },
};
</script>

<style scoped>
.form-control:disabled,
.form-control[readonly] {
  opacity: 0.7;
}
</style>
